import { BASE_DATA_TYPES } from '@/modules/base/components/generics/constants'
import { buildAndCreateCustomer } from '@/modules/customer/customerService'
import { buildAndCreateSupplier } from '@/modules/supplier/supplierService'

interface Data {
  addressKind: 'supplier' | 'customer';
  lastName: string;
}

type Callback = (result: { data: Data; type: string }) => void;

export const createSupplierCustomer = (data: Data, callback: Callback): void => {
  const type = data.addressKind === 'supplier' ? BASE_DATA_TYPES.SUPPLIER : BASE_DATA_TYPES.CUSTOMER

  if (type === BASE_DATA_TYPES.SUPPLIER) {
    buildAndCreateSupplier(data, data.lastName)
      .then((savedSupplier) => {
        callback({ data: savedSupplier, type: BASE_DATA_TYPES.SUPPLIER })
      })
  } else {
    buildAndCreateCustomer(data, data.lastName)
      .then((savedCustomer) => {
        callback({ data: savedCustomer, type: BASE_DATA_TYPES.CUSTOMER })
      })
  }
}
